import * as React from 'react';
import styled from 'styled-components';
import { callFunction } from '../utils/FirebaseUtils';
import ComponentWithUser from '../components/ComponentWithUser';
import User from '../data/User';
import { reportBFError } from '../utils/Tracker';
const Switch = require('rc-switch').default;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
`;

interface State {
  enabled: boolean;
}

export default class extends ComponentWithUser {
  state: State = {
    enabled: false
  };

  onUserReady(user: User) {
    this.getStatus();
  }
  getStatus() {
    callFunction('isSubscribedToNewsletter')
      .then((data: any) => {
        const enabled = data.data;
        if (this._mounted) {
          this.setState({
            enabled
          });
        }
      })
      .catch((e: Error) => {
        reportBFError(e);
      });
  }
  didChangeSwitch = () => {
    // log
    const enabled = !this.state.enabled;
    this.setState({ enabled });
    callFunction('changeSubscriptionToNewsletter', enabled)
      .then((data: any) => {
        this.setState({
          enabled: data.data === 'subscribed'
        });
      })
      .catch((e: Error) => {
        reportBFError(e);
      });
  };
  render() {
    return (
      <Wrapper>
        <span>Email updates:</span>
        <Switch checked={this.state.enabled} onChange={this.didChangeSwitch} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/account/EmailUpdates.tsx